import {Record} from 'immutable';

const record = Record({
  id: null,
  link: null,
  freePlan: false,
  iconSets: [],
  kitsAllowed: 0,
  downloadAllowed: false,
  iconsPerKitAllowed: 0,
  customIconsAllowed: 0,
  customTypefacesAllowed: 0,
  workingSetTypefacesAllowed: 0,
});

class Subscription extends record {
  get customIconsAllowed() {
    const val = super.customIconsAllowed;
    return (val === -1) ? Infinity : val;
  }

  get customTypefacesAllowed() {
    const val = super.customTypefacesAllowed;
    return (val === -1) ? Infinity : val;
  }

  get iconsPerKitAllowed() {
    const val = super.iconsPerKitAllowed;
    return (val === -1) ? Infinity : val;
  }

  get kitsAllowed() {
    const val = super.kitsAllowed;
    return (val === -1) ? Infinity : val;
  }

  get workingSetTypefacesAllowed() {
    const val = super.workingSetTypefacesAllowed;
    return (val === -1) ? Infinity : val;
  }

  toJS() {
    const extra = {
      customIconsAllowed: this.customIconsAllowed,
      customTypefacesAllowed: this.customTypefacesAllowed,
      iconsPerKitAllowed: this.iconsPerKitAllowed,
      kitsAllowed: this.kitsAllowed,
      workingSetTypefacesAllowed: this.workingSetTypefacesAllowed,
    };

    return Object.assign({}, super.toJS(), extra);
  }
}

export default Subscription;



// WEBPACK FOOTER //
// ./app/javascript/records/Subscription.js